<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <!--<i class="el-icon-arrow-left"></i>-->
      <!--<span class="title">My To Do List</span>-->
    </div>

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }"><i class="fa fa-home"></i> Home</router-link>
        </li>
        <li class="active">
          <small>Test Tree</small>
        </li>
      </ol>
    </div>


    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">

          DBB
          <el-row>
            <el-col :span ="10">
              <tree-select ref="firstTree"></tree-select>
            </el-col>

            <el-col :span ="4"></el-col>


            <el-col :span ="10">
              <tree-select ref="secondTree"></tree-select>
            </el-col>

          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>


</template>

<script>
  import treeSelect from '@/view/acs/tree/tree_selection.vue'


  export default {
    props: {

    },
    components: {
      treeSelect
    },
    data(){
      return{

        dataLoading: false,

        firstTreeData:[{
          "id": "056e58bbac794322a27ff1267195e49b",
          "appKey": "mdm",
          "parentId": null,
          "tagName": "Org",
          "isService": true,
          "tagHierarchy": null,
          "description": "组织结构",
          "sortIndex": 0,
          "gmtCreate": "2019-11-22 17:13:53",
          "gmtModified": "2019-11-22 17:13:53",
          "read": null,
          "write": null,
          "children": [{
            "id": "8c0aa0015b6b475686671d354d661e51",
            "appKey": "mdm",
            "parentId": "056e58bbac794322a27ff1267195e49b",
            "tagName": "CHANNEL",
            "isService": false,
            "tagHierarchy": null,
            "description": "渠道",
            "sortIndex": 0,
            "gmtCreate": "2019-11-28 09:58:32",
            "gmtModified": "2019-11-28 09:58:32",
            "read": null,
            "write": null,
            "children": [{
              "id": "610b0f644eb3435eabe0a9939d3a5bda",
              "appKey": "mdm",
              "parentId": "8c0aa0015b6b475686671d354d661e51",
              "tagName": "DIVISION",
              "isService": false,
              "tagHierarchy": null,
              "description": "division",
              "sortIndex": 0,
              "gmtCreate": "2019-11-28 10:01:21",
              "gmtModified": "2019-11-28 10:01:21",
              "read": null,
              "write": null,
              "children": [{
                "id": "fa0f637dc08549b3aa9efe49585fcc1c",
                "appKey": "mdm",
                "parentId": "610b0f644eb3435eabe0a9939d3a5bda",
                "tagName": "MARKET",
                "isService": false,
                "tagHierarchy": null,
                "description": "市场",
                "sortIndex": 0,
                "gmtCreate": "2019-11-28 10:01:36",
                "gmtModified": "2019-11-28 10:01:36",
                "read": null,
                "write": null,
                "children": null
              }]
            }]
          }]
        }, {
          "id": "9b489ef7a0ce4843a1cc6a1ed039d5e2",
          "appKey": "mdm",
          "parentId": null,
          "tagName": "Product",
          "isService": true,
          "tagHierarchy": null,
          "description": "产品",
          "sortIndex": 0,
          "gmtCreate": "2019-11-22 17:14:41",
          "gmtModified": "2019-11-22 17:14:41",
          "read": null,
          "write": null,
          "children": [{
            "id": "5e3118b0a76f4369a2ea147b14ae407f",
            "appKey": "mdm",
            "parentId": "9b489ef7a0ce4843a1cc6a1ed039d5e2",
            "tagName": "CB",
            "isService": true,
            "tagHierarchy": null,
            "description": "品类品牌层级",
            "sortIndex": 0,
            "gmtCreate": "2019-11-22 17:14:19",
            "gmtModified": "2019-11-22 17:14:19",
            "read": null,
            "write": null,
            "children": [{
              "id": "0f3a903e51954f91b40fc809962b03f8",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "Category",
              "isService": false,
              "tagHierarchy": null,
              "description": "品类",
              "sortIndex": 0,
              "gmtCreate": "2019-11-23 10:03:18",
              "gmtModified": "2019-11-23 10:03:18",
              "read": null,
              "write": null,
              "children": [{
                "id": "090bf870f56742a89e7438cd2b9614aa",
                "appKey": "mdm",
                "parentId": "0f3a903e51954f91b40fc809962b03f8",
                "tagName": "Brand",
                "isService": false,
                "tagHierarchy": null,
                "description": "品类",
                "sortIndex": 0,
                "gmtCreate": "2019-11-23 10:03:58",
                "gmtModified": "2019-11-23 10:03:58",
                "read": null,
                "write": null,
                "children": null
              }]
            }]
          }]
        }],

        secondTreeData:[{
          "id": "056e58bbac794322a27ff1267195e49b",
          "appKey": "mdm",
          "parentId": null,
          "tagName": "Org",
          "isService": 2,
          "tagHierarchy": null,
          "description": "组织结构",
          "sortIndex": 0,
          "gmtCreate": "2019-11-22 17:13:53",
          "gmtModified": "2019-11-22 17:13:53",
          "checked": false,
          "children": null
        }, {
          "id": "9b489ef7a0ce4843a1cc6a1ed039d5e2",
          "appKey": "mdm",
          "parentId": null,
          "tagName": "Product",
          "isService": 1,
          "tagHierarchy": null,
          "description": "产品",
          "sortIndex": 0,
          "gmtCreate": "2019-11-22 17:14:41",
          "gmtModified": "2019-11-22 17:14:41",
          "checked": false,
          "children": [{
            "id": "5e3118b0a76f4369a2ea147b14ae407f",
            "appKey": "mdm",
            "parentId": "9b489ef7a0ce4843a1cc6a1ed039d5e2",
            "tagName": "CB",
            "isService": 2,
            "tagHierarchy": null,
            "description": "品类品牌层级",
            "sortIndex": 0,
            "gmtCreate": "2019-11-22 17:14:19",
            "gmtModified": "2019-11-22 17:14:19",
            "checked": false,
            "children": [{
              "id": "677cb6c2ebdb4b56872a3bb100418fd6",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "BABY CARE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "护婴用品",
              "sortIndex": 2,
              "gmtCreate": "2019-11-25 19:12:33",
              "gmtModified": "2019-11-28 10:04:00",
              "checked": false,
              "children": [{
                "id": "5b50b93859b6432c9caa27b346b57094",
                "appKey": "mdm",
                "parentId": "677cb6c2ebdb4b56872a3bb100418fd6",
                "tagName": "Pampers",
                "isService": 0,
                "tagHierarchy": null,
                "description": "pampers",
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:07:51",
                "gmtModified": "2019-11-28 10:07:51",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "779cf8bca6e54fb4982b265d1e1990eb",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "PCC",
              "isService": 0,
              "tagHierarchy": null,
              "description": "随意品，你慢慢品",
              "sortIndex": 3,
              "gmtCreate": "2019-11-25 19:15:12",
              "gmtModified": "2019-11-28 10:04:16",
              "checked": false,
              "children": [{
                "id": "14d462dce36b4d879b9e9b667fa088e7",
                "appKey": "mdm",
                "parentId": "779cf8bca6e54fb4982b265d1e1990eb",
                "tagName": "Camay",
                "isService": 0,
                "tagHierarchy": null,
                "description": "camay",
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:08:21",
                "gmtModified": "2019-11-28 10:08:21",
                "checked": false,
                "children": null
              }, {
                "id": "3b9050f87cf946679a2d730153755f39",
                "appKey": "mdm",
                "parentId": "779cf8bca6e54fb4982b265d1e1990eb",
                "tagName": "Olay PCC",
                "isService": 0,
                "tagHierarchy": null,
                "description": "olay PCC",
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:08:33",
                "gmtModified": "2019-11-28 10:08:33",
                "checked": false,
                "children": null
              }, {
                "id": "b29767e5335743cba4d269537ef3d060",
                "appKey": "mdm",
                "parentId": "779cf8bca6e54fb4982b265d1e1990eb",
                "tagName": "Old Spice",
                "isService": 0,
                "tagHierarchy": null,
                "description": "Old Spice",
                "sortIndex": 3,
                "gmtCreate": "2019-11-28 10:08:43",
                "gmtModified": "2019-11-28 10:08:43",
                "checked": false,
                "children": null
              }, {
                "id": "1747cf9a7a49429193d763e8b4604c3f",
                "appKey": "mdm",
                "parentId": "779cf8bca6e54fb4982b265d1e1990eb",
                "tagName": "Safeguard",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 4,
                "gmtCreate": "2019-11-28 10:08:49",
                "gmtModified": "2019-11-28 10:08:49",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "468f058dda924566a4adbcb27695d723",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "APPLIANCES",
              "isService": 0,
              "tagHierarchy": null,
              "description": "appliances",
              "sortIndex": 4,
              "gmtCreate": "2019-11-28 10:04:36",
              "gmtModified": "2019-11-28 10:04:36",
              "checked": false,
              "children": [{
                "id": "ca6a9a2f93414e1dae245c312df15035",
                "appKey": "mdm",
                "parentId": "468f058dda924566a4adbcb27695d723",
                "tagName": "Braun",
                "isService": 0,
                "tagHierarchy": null,
                "description": "braun",
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:09:07",
                "gmtModified": "2019-11-28 10:09:07",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "137e73dc73ec4076bfad18bcdace5dce",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "FABRIC CARE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "fabric care",
              "sortIndex": 4,
              "gmtCreate": "2019-11-28 10:04:56",
              "gmtModified": "2019-11-28 10:04:56",
              "checked": false,
              "children": [{
                "id": "9a7d2b7fdd4a4528b6e3ebf4b0bc59a2",
                "appKey": "mdm",
                "parentId": "137e73dc73ec4076bfad18bcdace5dce",
                "tagName": "Ariel",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:10:07",
                "gmtModified": "2019-11-28 10:10:07",
                "checked": false,
                "children": null
              }, {
                "id": "9d042c9231414ceca8617c2e544bab66",
                "appKey": "mdm",
                "parentId": "137e73dc73ec4076bfad18bcdace5dce",
                "tagName": "Downy",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:10:29",
                "gmtModified": "2019-11-28 10:10:29",
                "checked": false,
                "children": null
              }, {
                "id": "db06417947bf47b0886f20bd432898ac",
                "appKey": "mdm",
                "parentId": "137e73dc73ec4076bfad18bcdace5dce",
                "tagName": "Febreze",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 3,
                "gmtCreate": "2019-11-28 10:10:44",
                "gmtModified": "2019-11-28 10:10:44",
                "checked": false,
                "children": null
              }, {
                "id": "6d5be1ed18ef47429a8e3cab31c7e31b",
                "appKey": "mdm",
                "parentId": "137e73dc73ec4076bfad18bcdace5dce",
                "tagName": "SARASA",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 4,
                "gmtCreate": "2019-11-28 10:10:56",
                "gmtModified": "2019-11-28 10:10:56",
                "checked": false,
                "children": null
              }, {
                "id": "e3276597798546f59bd047481188e116",
                "appKey": "mdm",
                "parentId": "137e73dc73ec4076bfad18bcdace5dce",
                "tagName": "Tide",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 4,
                "gmtCreate": "2019-11-28 10:11:08",
                "gmtModified": "2019-11-28 10:11:08",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "ba0e7f3da0c548b08e163772d0d594e4",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "FEMININE CARE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "feminine care",
              "sortIndex": 4,
              "gmtCreate": "2019-11-28 10:05:23",
              "gmtModified": "2019-11-28 10:05:23",
              "checked": false,
              "children": [{
                "id": "e3ac04454fc346c1a4e2779845b2dd94",
                "appKey": "mdm",
                "parentId": "ba0e7f3da0c548b08e163772d0d594e4",
                "tagName": "Naturella",
                "isService": 0,
                "tagHierarchy": null,
                "description": "naturella",
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:11:47",
                "gmtModified": "2019-11-28 10:11:47",
                "checked": false,
                "children": null
              }, {
                "id": "c7a7966b64404e7f8d0b915c45d937e1",
                "appKey": "mdm",
                "parentId": "ba0e7f3da0c548b08e163772d0d594e4",
                "tagName": "Tampax",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:11:55",
                "gmtModified": "2019-11-28 10:11:55",
                "checked": false,
                "children": null
              }, {
                "id": "6b6f32106cd2442cbc0e97aecfc8ea2f",
                "appKey": "mdm",
                "parentId": "ba0e7f3da0c548b08e163772d0d594e4",
                "tagName": "Whisper",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:12:06",
                "gmtModified": "2019-11-28 10:12:06",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "9ade0a7ae61441b9af715f982ff46f41",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "HAIR CARE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "护发用品",
              "sortIndex": 5,
              "gmtCreate": "2019-11-28 10:05:43",
              "gmtModified": "2019-11-28 10:05:43",
              "checked": false,
              "children": [{
                "id": "358eb9b98e954429924e44e9d5f031fc",
                "appKey": "mdm",
                "parentId": "9ade0a7ae61441b9af715f982ff46f41",
                "tagName": "Aussie",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:12:16",
                "gmtModified": "2019-11-28 10:12:16",
                "checked": false,
                "children": null
              }, {
                "id": "249b5605217c4787bb0e9dac171cf7df",
                "appKey": "mdm",
                "parentId": "9ade0a7ae61441b9af715f982ff46f41",
                "tagName": "Clairol",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:12:30",
                "gmtModified": "2019-11-28 10:12:30",
                "checked": false,
                "children": null
              }, {
                "id": "81b9022f2b6540dd8d00f26ed94f2973",
                "appKey": "mdm",
                "parentId": "9ade0a7ae61441b9af715f982ff46f41",
                "tagName": "H&S",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:12:40",
                "gmtModified": "2019-11-28 10:12:40",
                "checked": false,
                "children": null
              }, {
                "id": "433a447564d44abcb9014744f29bd9b5",
                "appKey": "mdm",
                "parentId": "9ade0a7ae61441b9af715f982ff46f41",
                "tagName": "Pantene",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 3,
                "gmtCreate": "2019-11-28 10:12:48",
                "gmtModified": "2019-11-28 10:12:48",
                "checked": false,
                "children": null
              }, {
                "id": "68ccd715e9ef407a9e08df976bbb5223",
                "appKey": "mdm",
                "parentId": "9ade0a7ae61441b9af715f982ff46f41",
                "tagName": "Rejoice",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 3,
                "gmtCreate": "2019-11-28 10:12:58",
                "gmtModified": "2019-11-28 10:12:58",
                "checked": false,
                "children": null
              }, {
                "id": "7bdba61347904ae58264e592aa33f5fa",
                "appKey": "mdm",
                "parentId": "9ade0a7ae61441b9af715f982ff46f41",
                "tagName": "VS",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 3,
                "gmtCreate": "2019-11-28 10:13:06",
                "gmtModified": "2019-11-28 10:13:06",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "5fa49207e71a45f6929864efde268026",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "OTHERS",
              "isService": 0,
              "tagHierarchy": null,
              "description": "others",
              "sortIndex": 5,
              "gmtCreate": "2019-11-28 10:06:12",
              "gmtModified": "2019-11-28 10:06:12",
              "checked": false,
              "children": [{
                "id": "39d39cad9b1b402f87f3a5eeebbd37aa",
                "appKey": "mdm",
                "parentId": "5fa49207e71a45f6929864efde268026",
                "tagName": "Others",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:14:33",
                "gmtModified": "2019-11-28 10:14:33",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "09c40fe4058f4276a1e2a1ef0027e25f",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "POWER BRUSH",
              "isService": 0,
              "tagHierarchy": null,
              "description": "power brush",
              "sortIndex": 5,
              "gmtCreate": "2019-11-28 10:06:36",
              "gmtModified": "2019-11-28 10:06:36",
              "checked": false,
              "children": [{
                "id": "244e8eb2976241d8868e32d8337d62c1",
                "appKey": "mdm",
                "parentId": "09c40fe4058f4276a1e2a1ef0027e25f",
                "tagName": "Oral-B.PB",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:14:45",
                "gmtModified": "2019-11-28 10:14:45",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "b1837ad477704f52960411a8e8709b38",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "PRESTIGE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "prestige",
              "sortIndex": 5,
              "gmtCreate": "2019-11-28 10:06:54",
              "gmtModified": "2019-11-28 10:06:54",
              "checked": false,
              "children": [{
                "id": "da7e1afa85094b23b45856893169bbed",
                "appKey": "mdm",
                "parentId": "b1837ad477704f52960411a8e8709b38",
                "tagName": "SK-II",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:14:57",
                "gmtModified": "2019-11-28 10:14:57",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "5dfc629bab124f10ab9e6b60ccf3e7bf",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "SHAVE CARE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "shave care",
              "sortIndex": 5,
              "gmtCreate": "2019-11-28 10:07:11",
              "gmtModified": "2019-11-28 10:07:11",
              "checked": false,
              "children": [{
                "id": "03aec20a44344414b2bb57a6d03bf79d",
                "appKey": "mdm",
                "parentId": "5dfc629bab124f10ab9e6b60ccf3e7bf",
                "tagName": "Gillette",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:15:12",
                "gmtModified": "2019-11-28 10:15:12",
                "checked": false,
                "children": null
              }, {
                "id": "6e1b5a007e234420b090fe1fdc1c8773",
                "appKey": "mdm",
                "parentId": "5dfc629bab124f10ab9e6b60ccf3e7bf",
                "tagName": "Venus",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:15:22",
                "gmtModified": "2019-11-28 10:15:22",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "b448dc60d1f84bafa2234198f6ed973c",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "SKIN CARE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "护肤用品",
              "sortIndex": 5,
              "gmtCreate": "2019-11-28 10:07:38",
              "gmtModified": "2019-11-28 10:07:38",
              "checked": false,
              "children": [{
                "id": "5e45dde6886c4f438d0196dfab27de30",
                "appKey": "mdm",
                "parentId": "b448dc60d1f84bafa2234198f6ed973c",
                "tagName": "Olay SC",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:15:35",
                "gmtModified": "2019-11-28 10:15:35",
                "checked": false,
                "children": null
              }]
            }, {
              "id": "6872c9f4ee9440a2900863153d706652",
              "appKey": "mdm",
              "parentId": "5e3118b0a76f4369a2ea147b14ae407f",
              "tagName": "ORAL CARE",
              "isService": 0,
              "tagHierarchy": null,
              "description": "oral care",
              "sortIndex": 5,
              "gmtCreate": "2019-11-28 10:14:20",
              "gmtModified": "2019-11-28 10:14:20",
              "checked": false,
              "children": [{
                "id": "15ea9e2d20d240dcbd5668f17c759244",
                "appKey": "mdm",
                "parentId": "6872c9f4ee9440a2900863153d706652",
                "tagName": "Crest",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 1,
                "gmtCreate": "2019-11-28 10:15:48",
                "gmtModified": "2019-11-28 10:15:48",
                "checked": false,
                "children": null
              }, {
                "id": "a45c3a2474b84c01a940522f32480299",
                "appKey": "mdm",
                "parentId": "6872c9f4ee9440a2900863153d706652",
                "tagName": "Oral-B",
                "isService": 0,
                "tagHierarchy": null,
                "description": null,
                "sortIndex": 2,
                "gmtCreate": "2019-11-28 10:16:00",
                "gmtModified": "2019-11-28 10:16:00",
                "checked": false,
                "children": null
              }]
            }]
          }]
        }]

      }
    },
    computed: {

    },
    created(){

    },
    mounted(){
      this.$refs.firstTree.init(this.firstTreeData,"tagName");
      this.$refs.secondTree.init(this.secondTreeData, "tagName");
    },

    methods: {

    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/acs/test.vue